<div class="main-driver-card">
  <!-- Cabecera del Módulo -->
  <div class="module-header d-flex justify-content-between align-items-center">
    <div>
      <h2 class="module-title">{{ titulo }}</h2>
      <p class="module-subtitle">Siga los pasos para registrar un nuevo conductor en la plataforma administrativamente</p>
    </div>
  </div>

  <!-- Stepper Asistente -->
  <div class="container-fluid p-0">
    <p-stepper [(activeStep)]="active" [linear]="true">
      
      <!-- PASO 1: Datos Personales -->
      <p-stepperPanel header="{{ step1_titulo }}">
        <ng-template pTemplate="content">
          <form (ngSubmit)="next()" [formGroup]="formConductor" class="mt-4">
            <div class="detail-card">
              <h3 class="detail-card-title">
                <i class="pi pi-user"></i> Información Básica y de Contacto
              </h3>
              
              <div class="row">
                <!-- Nombre -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Nombre*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-user"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="dri_name"
                      placeholder="Ingrese los nombres"
                    />
                  </p-iconField>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formConductor.controls['dri_name'].hasError('required') && 
                      formConductor.controls['dri_name'].touched
                    "
                  >
                    El nombre es requerido.
                  </span>
                </div>

                <!-- Apellido -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Apellido*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-user"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="dri_last_name"
                      placeholder="Ingrese los apellidos"
                    />
                  </p-iconField>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formConductor.controls['dri_last_name'].hasError('required') && 
                      formConductor.controls['dri_last_name'].touched
                    "
                  >
                    El apellido es requerido.
                  </span>
                </div>
              </div>

              <div class="row">
                <!-- Teléfono -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Teléfono / Celular*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-phone"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="dri_phone"
                      placeholder="Ej: +593987654321"
                    />
                  </p-iconField>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formConductor.controls['dri_phone'].hasError('required') && 
                      formConductor.controls['dri_phone'].touched
                    "
                  >
                    El teléfono es requerido.
                  </span>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formConductor.controls['dri_phone'].hasError('pattern') && 
                      formConductor.controls['dri_phone'].touched
                    "
                  >
                    El teléfono debe contener únicamente números.
                  </span>
                </div>

                <!-- Nro. Licencia -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Nro. Licencia de Conducir*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-id-card"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="dri_number_license"
                      placeholder="Ingrese el número de licencia"
                    />
                  </p-iconField>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formConductor.controls['dri_number_license'].hasError('required') && 
                      formConductor.controls['dri_number_license'].touched
                    "
                  >
                    El número de licencia es requerido.
                  </span>
                </div>
              </div>

              <!-- Dirección -->
              <div class="row">
                <div class="col-12 mb-3">
                  <label class="form-label-edit">Dirección Residencial*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-map-marker"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="dri_address"
                      placeholder="Calle principal, secundaria y nro. de casa"
                    />
                  </p-iconField>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formConductor.controls['dri_address'].hasError('required') && 
                      formConductor.controls['dri_address'].touched
                    "
                  >
                    La dirección residencial es requerida.
                  </span>
                </div>
              </div>
            </div>

            <!-- Tarjeta: Parámetros de Seguridad -->
            <div class="detail-card">
              <h3 class="detail-card-title">
                <i class="pi pi-lock"></i> Credenciales y Seguridad
              </h3>
              <div class="row">
                <!-- Nro Social -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Nro. de Seguro Social / Identificación*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-shield"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="dri_social"
                      placeholder="Ingrese la identificación social"
                    />
                  </p-iconField>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formConductor.controls['dri_social'].hasError('required') && 
                      formConductor.controls['dri_social'].touched
                    "
                  >
                    El número social es requerido.
                  </span>
                </div>

                <!-- Password -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Contraseña de Aplicación*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-key"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="dri_password"
                      placeholder="Mínimo 6 caracteres"
                    />
                  </p-iconField>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formConductor.controls['dri_password'].hasError('required') && 
                      formConductor.controls['dri_password'].touched
                    "
                  >
                    La contraseña de acceso es requerida.
                  </span>
                </div>
              </div>

              <!-- Términos y Condiciones -->
              <div class="row mt-2">
                <div class="col-12 d-flex align-items-center gap-2">
                  <p-checkbox
                    formControlName="dri_term_conditions"
                    [binary]="true"
                    inputId="term_conditions"
                  />
                  <label for="term_conditions" class="form-label-edit m-0 cursor-pointer">
                    Acepto los Términos y Condiciones de uso del servicio de Taxis*
                  </label>
                </div>
              </div>
            </div>

            <!-- Botón de Navegación -->
            <div class="d-flex justify-content-end mt-4">
              <p-button
                label="Continuar"
                icon="pi pi-arrow-right"
                iconPos="right"
                type="submit"
                [disabled]="formConductor.invalid"
                [rounded]="true"
                severity="success"
              />
            </div>
          </form>
        </ng-template>
      </p-stepperPanel>

      <!-- PASO 2: Datos de la Compañía -->
      <p-stepperPanel header="{{ step2_titulo }}">
        <ng-template pTemplate="content">
          <div class="mt-4">
            <div class="detail-card">
              <h3 class="detail-card-title">
                <i class="pi pi-briefcase"></i> Selección de Compañía Adscrita
              </h3>
              <p class="text-secondary small mb-4">Seleccione una de las siguientes compañías de transporte a la cual estará afiliado el conductor.</p>
              
              <p-table
                [value]="ltsCompany"
                [(selection)]="selectCompany"
                dataKey="com_id"
                [tableStyle]="{ 'min-width': '50rem' }"
                responsiveLayout="scroll"
                [paginator]="true"
                [rows]="5"
                [rowsPerPageOptions]="[5, 10, 15]"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Compañías"
                styleClass="p-datatable-striped p-datatable-sm"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th id="tbselect" style="width: 4rem"></th>
                    <th id="tbnamecom">Compañía</th>
                    <th id="tbstatuscom">Estatus</th>
                    <th id="tbphonecom">Teléfono</th>
                    <th id="tbaddresscom">Dirección</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-company>
                  <tr>
                    <td>
                      <div class="d-flex justify-content-center">
                        <p-radioButton
                          [inputId]="company.com_id.toString()"
                          name="company"
                          [value]="company"
                          [(ngModel)]="selectCompany"
                        />
                      </div>
                    </td>
                    <td class="font-semibold">{{ company.com_name }}</td>
                    <td>
                      <span class="status-pill" [class.status-active]="company.estado" [class.status-inactive]="!company.estado">
                        {{ company.estado ? 'Activa' : 'Inactiva' }}
                      </span>
                    </td>
                    <td>{{ company.com_phone }}</td>
                    <td>{{ company.com_address }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>

            <!-- Botones de Navegación -->
            <div class="d-flex justify-content-between mt-4">
              <p-button label="Atrás" icon="pi pi-arrow-left" [outlined]="true" severity="secondary" [rounded]="true" (onClick)="back()" />
              <p-button
                label="Continuar"
                icon="pi pi-arrow-right"
                iconPos="right"
                [rounded]="true"
                severity="success"
                [disabled]="!selectCompany"
                (onClick)="next()"
              />
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- PASO 3: Datos del Vehículo -->
      <p-stepperPanel header="{{ step3_titulo }}">
        <ng-template pTemplate="content">
          <form (ngSubmit)="next()" [formGroup]="formVehiculo" class="mt-4">

            <!-- Tarjeta: Especificaciones Básicas -->
            <div class="detail-card">
              <h3 class="detail-card-title">
                <i class="pi pi-info-circle"></i> Especificaciones Básicas
              </h3>

              <div class="row">
                <!-- Placa -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Placa*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-id-card"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_plate"
                      placeholder="Ej: ABC-1234"
                    />
                  </p-iconField>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formVehiculo.controls['veh_plate'].hasError('required') &&
                      formVehiculo.controls['veh_plate'].touched
                    "
                  >
                    La placa es requerida.
                  </span>
                </div>

                <!-- Nro. Registro -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Nro. Registro*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-file"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_num_registration"
                      placeholder="Ingrese el nro de registro"
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_num_registration'].hasError('required') && formVehiculo.controls['veh_num_registration'].touched) {
                    <span class="text-danger labelError">El número de registro es requerido.</span>
                  }
                </div>
              </div>

              <div class="row">
                <!-- Marca -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Marca*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-tag"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_brand"
                      placeholder="Ej: Chevrolet, Hyundai, Renault"
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_brand'].hasError('required') && formVehiculo.controls['veh_brand'].touched) {
                    <span class="text-danger labelError">La marca es requerida.</span>
                  }
                </div>

                <!-- Modelo -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Modelo*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-car"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_model"
                      placeholder="Ej: Logan, Accent, etc."
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_model'].hasError('required') && formVehiculo.controls['veh_model'].touched) {
                    <span class="text-danger labelError">El modelo es requerido.</span>
                  }
                </div>
              </div>
            </div>

            <!-- Tarjeta: Detalles Técnicos -->
            <div class="detail-card">
              <h3 class="detail-card-title">
                <i class="pi pi-cog"></i> Detalles Técnicos
              </h3>

              <div class="row">
                <!-- Año -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Año*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-calendar"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_anio"
                      placeholder="Ej: 2023"
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_anio'].hasError('required') && formVehiculo.controls['veh_anio'].touched) {
                    <span class="text-danger labelError">El año es requerido.</span>
                  }
                </div>

                <!-- Color -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Color*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-palette"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_color"
                      placeholder="Ej: Amarillo, Blanco"
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_color'].hasError('required') && formVehiculo.controls['veh_color'].touched) {
                    <span class="text-danger labelError">El color es requerido.</span>
                  }
                </div>
              </div>

              <div class="row">
                <!-- Cantidad de Ocupantes -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Cantidad de Ocupantes*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-users"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_quantity_person"
                      placeholder="Ej: 4"
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_quantity_person'].hasError('required') && formVehiculo.controls['veh_quantity_person'].touched) {
                    <span class="text-danger labelError">La cantidad de ocupantes es requerida.</span>
                  }
                </div>
              </div>
            </div>

            <!-- Tarjeta: Estado y Seguros -->
            <div class="detail-card">
              <h3 class="detail-card-title">
                <i class="pi pi-shield"></i> Estado Legal y Revisiones
              </h3>
              <div class="row">
                <!-- Inspección -->
                <div class="col-12 col-md-6 mb-3 d-flex align-items-center gap-2">
                  <p-checkbox
                    formControlName="veh_inspection"
                    [binary]="true"
                    inputId="veh_inspection"
                  />
                  <label for="veh_inspection" class="form-label-edit m-0 cursor-pointer">
                    Inspección Vehicular Aprobada*
                  </label>
                </div>

                <!-- Seguro -->
                <div class="col-12 col-md-6 mb-3 d-flex align-items-center gap-2">
                  <p-checkbox
                    formControlName="veh_secure"
                    [binary]="true"
                    inputId="veh_secure"
                  />
                  <label for="veh_secure" class="form-label-edit m-0 cursor-pointer">
                    Seguro Vigente *
                  </label>
                </div>
              </div>
            </div>

            <!-- Botones de Navegación -->
            <div class="d-flex justify-content-between mt-4">
              <p-button label="Atrás" icon="pi pi-arrow-left" [outlined]="true" severity="secondary" [rounded]="true" (onClick)="back()" />
              <p-button
                label="Continuar"
                icon="pi pi-arrow-right"
                iconPos="right"
                type="submit"
                [disabled]="formVehiculo.invalid"
                [rounded]="true"
                severity="success"
              />
            </div>
          </form>
        </ng-template>
      </p-stepperPanel>

      <!-- PASO 4: Documentos del Conductor -->
      <p-stepperPanel header="{{ step4_titulo }}">
        <ng-template pTemplate="content">
          <div class="mt-4">
            <div class="row">
              <!-- Columna Izquierda: Zona de Carga -->
              <div class="col-12 col-md-5">
                <div class="detail-card">
                  <h3 class="detail-card-title">
                    <i class="pi pi-cloud-upload"></i> Subir Archivo
                  </h3>

                  <div class="mb-3">
                    <label class="form-label-edit">1. Seleccione el Tipo de Documento</label>
                    <p-dropdown
                      [options]="ltsTypeDocument"
                      [(ngModel)]="selectedTypeDocument"
                      optionLabel="typ_name"
                      placeholder="Seleccionar tipo"
                      styleClass="largeInput"
                      [appendTo]="'body'"
                    />
                  </div>

                  <div class="mb-2">
                    <label class="form-label-edit">2. Busque y Adjunte el Archivo</label>
                    <div class="logo-upload-box text-center p-3">
                      <p-fileUpload
                        #fileUpload
                        mode="basic"
                        chooseLabel="Adjuntar"
                        chooseIcon="pi pi-plus"
                        [showUploadButton]="false"
                        [showCancelButton]="false"
                        maxFileSize="7340032"
                        (onSelect)="onUploadAuto($event.files, fileUpload)"
                        accept="image/png,image/jpeg,application/pdf"
                        [multiple]="false"
                        styleClass="p-button-success p-button-outlined w-100"
                      >
                      </p-fileUpload>
                      <p class="text-secondary small mt-2 mb-0">Imágenes o PDFs hasta 7MB</p>
                    </div>
                  </div>

                  <div class="alert alert-info mt-3 py-2 px-3 border-0 rounded-3">
                    <i class="pi pi-info-circle me-1 small"></i>
                    <span class="small font-bold">Nota obligatoria:</span>
                    <p class="small m-0 mt-1">El sistema requiere de forma obligatoria que se cargue una <strong>Foto de Perfil</strong> (Código Tipo 1) para guardar el conductor.</p>
                  </div>
                </div>
              </div>

              <!-- Columna Derecha: Tabla de Documentos Cargados -->
              <div class="col-12 col-md-7">
                <div class="detail-card h-100">
                  <h3 class="detail-card-title">
                    <i class="pi pi-file"></i> Documentos Adjuntados en Lote
                  </h3>

                  @if (ltsDocument.length === 0) {
                    <div class="text-center py-5">
                      <i class="pi pi-folder-open text-muted mb-3" style="font-size: 3rem;"></i>
                      <p class="text-muted">Ningún documento adjuntado todavía. Use el panel izquierdo para cargar.</p>
                    </div>
                  } @else {
                    <p-table
                      [value]="ltsDocument"
                      [tableStyle]="{ 'min-width': '100%' }"
                      styleClass="p-datatable-sm"
                    >
                      <ng-template pTemplate="header">
                        <tr>
                          <th id="th-img-cr">Miniatura</th>
                          <th id="th-name-cr">Archivo</th>
                          <th id="th-type-cr">Tipo</th>
                          <th id="th-act-cr" style="width: 3rem"></th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-doc let-index="rowIndex">
                        <tr>
                          <td>
                            @if (doc.filstring) {
                              <p-image
                                [src]="doc.filstring"
                                alt="Miniatura"
                                width="44"
                                height="44"
                                imageClass="rounded border shadow-sm"
                                [style]="{ 'object-fit': 'cover' }"
                              />
                            } @else {
                              <i class="pi pi-file text-emerald-500" style="font-size: 1.5rem"></i>
                            }
                          </td>
                          <td class="text-truncate font-semibold" style="max-width: 150px;">{{ doc.file.name }}</td>
                          <td>
                            <span class="status-pill status-active">
                              {{ doc.typeDocument.typ_name }}
                            </span>
                          </td>
                          <td>
                            <p-button
                              icon="pi pi-trash"
                              [rounded]="true"
                              [text]="true"
                              severity="danger"
                              (onClick)="removeFile(index)"
                            ></p-button>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  }
                </div>
              </div>
            </div>

            <!-- Botones de Navegación -->
            <div class="d-flex justify-content-between mt-4">
              <p-button label="Atrás" icon="pi pi-arrow-left" [outlined]="true" severity="secondary" [rounded]="true" (onClick)="back()" />
              <p-button
                label="Guardar y Crear Conductor"
                icon="pi pi-save"
                [rounded]="true"
                severity="success"
                [loading]="loading"
                (onClick)="crearDriver()"
              />
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- PASO 5: Documentos del Vehículo (se omite si la placa quedó en conflicto) -->
      <p-stepperPanel header="{{ step5_titulo }}">
        <ng-template pTemplate="content">
          <div class="mt-4">
            <div class="row">
              <!-- Columna Izquierda: Zona de Carga -->
              <div class="col-12 col-md-5">
                <div class="detail-card">
                  <h3 class="detail-card-title">
                    <i class="pi pi-cloud-upload"></i> Subir Documentos del Vehículo
                  </h3>

                  <div class="mb-3">
                    <label class="form-label-edit">1. Seleccione el Tipo de Documento</label>
                    <p-dropdown
                      [options]="ltsTypeDocumentVehicle"
                      [(ngModel)]="selectedTypeDocumentVehicle"
                      optionLabel="typ_name"
                      placeholder="Seleccionar tipo"
                      styleClass="largeInput"
                      [appendTo]="'body'"
                    />
                  </div>

                  <div class="mb-2">
                    <label class="form-label-edit">2. Busque y Adjunte el Archivo</label>
                    <div class="logo-upload-box text-center p-3">
                      <p-fileUpload
                        #fileUploadVehicle
                        mode="basic"
                        chooseLabel="Adjuntar"
                        chooseIcon="pi pi-plus"
                        [showUploadButton]="false"
                        [showCancelButton]="false"
                        maxFileSize="7340032"
                        (onSelect)="onUploadAutoVehicle($event.files, fileUploadVehicle)"
                        accept="image/png,image/jpeg,application/pdf"
                        [multiple]="false"
                        styleClass="p-button-success p-button-outlined w-100"
                      >
                      </p-fileUpload>
                      <p class="text-secondary small mt-2 mb-0">Imágenes o PDFs hasta 7MB</p>
                    </div>
                  </div>

                  <div class="alert alert-info mt-3 py-2 px-3 border-0 rounded-3">
                    <i class="pi pi-info-circle me-1 small"></i>
                    <span class="small">Los documentos del vehículo son opcionales acá; también se pueden completar después desde el detalle del vehículo.</span>
                  </div>
                </div>
              </div>

              <!-- Columna Derecha: Tabla de Documentos Cargados -->
              <div class="col-12 col-md-7">
                <div class="detail-card h-100">
                  <h3 class="detail-card-title">
                    <i class="pi pi-file"></i> Documentos Adjuntados en Lote
                  </h3>

                  @if (ltsDocumentVehicle.length === 0) {
                    <div class="text-center py-5">
                      <i class="pi pi-folder-open text-muted mb-3" style="font-size: 3rem;"></i>
                      <p class="text-muted">Ningún documento adjuntado todavía. Use el panel izquierdo para cargar.</p>
                    </div>
                  } @else {
                    <p-table
                      [value]="ltsDocumentVehicle"
                      [tableStyle]="{ 'min-width': '100%' }"
                      styleClass="p-datatable-sm"
                    >
                      <ng-template pTemplate="header">
                        <tr>
                          <th id="th-img-veh">Miniatura</th>
                          <th id="th-name-veh">Archivo</th>
                          <th id="th-type-veh">Tipo</th>
                          <th id="th-act-veh" style="width: 3rem"></th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-doc let-index="rowIndex">
                        <tr>
                          <td>
                            @if (doc.filstring) {
                              <p-image
                                [src]="doc.filstring"
                                alt="Miniatura"
                                width="44"
                                height="44"
                                imageClass="rounded border shadow-sm"
                                [style]="{ 'object-fit': 'cover' }"
                              />
                            } @else {
                              <i class="pi pi-file text-emerald-500" style="font-size: 1.5rem"></i>
                            }
                          </td>
                          <td class="text-truncate font-semibold" style="max-width: 150px;">{{ doc.file.name }}</td>
                          <td>
                            <span class="status-pill status-active">
                              {{ doc.typeDocument.typ_name }}
                            </span>
                          </td>
                          <td>
                            <p-button
                              icon="pi pi-trash"
                              [rounded]="true"
                              [text]="true"
                              severity="danger"
                              (onClick)="removeFileVehicle(index)"
                            ></p-button>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  }
                </div>
              </div>
            </div>

            <!-- Botones de Navegación -->
            <div class="d-flex justify-content-end mt-4">
              <p-button
                label="Guardar y Finalizar"
                icon="pi pi-save"
                [rounded]="true"
                severity="success"
                (onClick)="guardarDocumentosVehiculo()"
              />
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- PASO 6: Hecho / Éxito -->
      <p-stepperPanel header="{{ step6_titulo }}">
        <ng-template pTemplate="content">
          <div class="success-container">
            <div class="success-icon-wrapper">
              <i class="pi pi-check"></i>
            </div>
            @if (vehicleConflict) {
              <h3 class="success-title">Conductor Registrado — Pendiente por Conflicto de Placa</h3>
              <p class="success-subtitle">
                El conductor fue creado, pero la placa ingresada ya está asignada a otro conductor activo. Quedó en estado <strong>Pendiente</strong> hasta que se resuelva el conflicto desde el listado de conductores.
              </p>
            } @else {
              <h3 class="success-title">¡Conductor y Vehículo Registrados con Éxito!</h3>
              <p class="success-subtitle">
                El conductor y su vehículo fueron almacenados en el sistema. Los documentos cargados ya se encuentran disponibles para validación administrativa.
              </p>
            }
            @if (resultMessage) {
              <div class="alert" [ngClass]="vehicleConflict ? 'alert-warning' : 'alert-success'" style="max-width: 560px; margin: 0 auto 1.5rem;">
                <i class="pi pi-info-circle me-1"></i>
                <span class="small">{{ resultMessage }}</span>
              </div>
            }

            <div class="d-flex justify-content-center gap-3">
              <p-button
                label="Registrar Otro Conductor"
                icon="pi pi-user-plus"
                [rounded]="true"
                severity="success"
                [outlined]="true"
                (onClick)="backStart()"
              />
              <p-button
                label="Volver al Listado"
                icon="pi pi-list"
                [rounded]="true"
                severity="success"
                routerLink="/admin/driver"
              />
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

    </p-stepper>
  </div>
</div>
